export enum ProductId {
    Oto360Insurance = 5,
    Oto360Takaful = 6
  }
  